import React, { FC, ReactNode } from 'react';
import { useLocation, useHistory } from 'react-router';
import { Grid, GridSize, Hidden, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import CloseIcon from '@material-ui/icons/Close';
import classNames from 'classnames';

import { Index } from 'Links';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.custom.mainOffset,
    margin: theme.custom.bodyMargin,
    maxWidth: theme.custom.bodyMaxWidth,
  },
  fullWidth: {
    [theme.breakpoints.up('lg')]: {
      maxWidth: theme.custom.bodyMaxWidth - 120,
    },
  },
  item: {
    position: 'relative',
  },
  button: {
    position: 'absolute',
    left: -theme.spacing(1) * 7,
    backgroundColor: theme.custom.palette.grey3,
    color: theme.custom.palette.black2,
    '&:hover': {
      backgroundColor: theme.custom.palette.grey2,
      color: theme.custom.palette.black1,
    },
  },
  gutterBottom: {
    marginBottom: theme.spacing(15),
  },
}));

interface IProps {
  main: ReactNode;
  navigation?: boolean;
  mobileSize?: GridSize;
  tabletSize?: GridSize;
  desktopSize?: GridSize;
  fullWidth?: boolean;
  gutterBottom?: boolean;
}

const App1Column: FC<IProps> = props => {
  const { fullWidth, main, navigation, desktopSize, gutterBottom, mobileSize, tabletSize } = props;

  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const containerClasses = classNames(classes.container, {
    [classes.fullWidth]: !fullWidth,
    [classes.gutterBottom]: gutterBottom,
  });

  function renderClose() {
    return (
      <IconButton component={Index} className={classes.button} color="inherit">
        <CloseIcon />
      </IconButton>
    );
  }

  function renderBack() {
    return (
      <IconButton className={classes.button} color="inherit" onClick={history.goBack}>
        <ChevronLeft />
      </IconButton>
    );
  }

  function renderNavigation() {
    return <Hidden mdDown>{location.key ? renderBack() : renderClose()}</Hidden>;
  }

  return (
    <div className={containerClasses}>
      <Grid container justify="center">
        <Grid item xs={mobileSize} md={tabletSize} lg={desktopSize} className={classes.item}>
          {navigation && renderNavigation()}
          {main}
        </Grid>
      </Grid>
    </div>
  );
};

App1Column.defaultProps = {
  navigation: false,
  desktopSize: 12,
  tabletSize: 12,
  mobileSize: 12,
  fullWidth: false,
};

export default App1Column;
